// src/App.js
import React, { useState, useEffect } from 'react';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from './firebase-auth';
import SignIn from './components/SigninPage';
import Home from './components/Home';
import Header from './components/Header';
// import LandingPage from './components/LandingPage';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import ReactGA from 'react-ga4';
import TermsAndPrivacy from './components/TermsAndPrivacy';
import BlogPost from './components/Blog';
import BlogPage from './components/Blogs'
import CompetitionFileUpload from './components/CompetitionFileUpload';
import LandingPage from './components/LandingPageClaude'
import DatasetListing from './components/DatasetListPage';
import FlowDiagram from './components/FlowChartDiagram';
// import SignupPageSample from './components/SignupPageSample'
import SignupPageClaude from './components/SignupPageClaude';
import PricingSection from './components/PricingSection';
import PricingPageStudent from './components/PricingPageStudent';
import PricingPageComplete from './components/PricingPageComplete';
import CreditCalculator from './components/CreditHistory';
import EntryTable from './components/PromptHistory';
import FeedbackPage from './components/EmailFeedback';
import PreviewPage from './components/PreviewPage';
import CollaborativeEditor from './components/CollaborativeEditor';
// import SignupPageTrial from './components/SignupPageTrial';
// import FeedbackModal from './components/FeedbackPopup';
import DataMarketplace from './components/DataMarketplace';
import CSVEditor from './components/DataCleaner'
import ModelEvaluationUI from './components/ModelEvalLeaderboard';
import MyOrdersPage from './components/MyOrders';
import ReviewerApplication from './components/ReviewerApplication';
import StudentAmbassadors from './components/StudentAmbassadors';
import NestedJSONViewerPage from './components/NestedJSONViewerPage';

function App() {

  ReactGA.initialize('G-CCYJ25YQQ8');
  const [user, setUser] = useState(null);
  const [test_data, setTestData] = useState([{ "a": "1", "b": "2", "c": "3" }, { "a": "4", "b": "5", "c": "6" }]);
  const [columnDefs, setColumnDefs] = useState([{ "headerName": "a", "field": "a" }, { "headerName": "b", "field": "b" }, { "headerName": "c", "field": "c" }]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
      } else {
        setUser(null);
      }
    });

    // Clean up subscription on unmount
    return () => unsubscribe();
  }, []);

  return (
    <div>
      <BrowserRouter>
        {<Header title="DataCreator AI" user={user} />}
        <Routes>
          <Route path="/" element={user ? <CSVEditor user={user} /> : <LandingPage />} />
          {/* <Route path="/" element={ user ? <Home user={user} /> : <SignupPageClaude setUser={setUser} />} /> */}
          <Route path="/competition" element={user ? <CompetitionFileUpload user={user} /> : <SignupPageClaude setUser={setUser} />} />
          <Route path="/terms-and-privacy" element={<TermsAndPrivacy />} />
          {/* <Route path="/flow-diagram" element={<FlowDiagram />} /> */}
          <Route path="/clean" element={<CSVEditor user={user} />} />
          <Route path="/pricing" element={<PricingSection />} />
          <Route path="/pricing/students" element={<PricingPageStudent />} />
          <Route path="/pricing/all" element={<PricingPageComplete />} />
          <Route path="/creditinfo" element={user ? <CreditCalculator /> : <SignupPageClaude setUser={setUser} />} />
          <Route path="/signin" element={<SignupPageClaude setUser={setUser} />} />
          <Route path="/cdatasets" element={<DatasetListing user={user} />} />
          <Route path="/datahistory" element={user ? <EntryTable user={user} /> : <SignupPageClaude setUser={setUser} />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          <Route path="/marketplace" element={<DataMarketplace />} />
          <Route path="/evalleader" element={user ? <ModelEvaluationUI user={user} /> : <SignupPageClaude setUser={setUser} />} />
          <Route path="/orders" element={user ? <MyOrdersPage user={user} /> : <SignupPageClaude setUser={setUser} />} />
          <Route path="/reviewer-apply" element={<ReviewerApplication user={user} />} />
          <Route path="/student-ambassadors" element={<StudentAmbassadors />} />
          <Route path="/nested-json" element={<NestedJSONViewerPage user={user} />} />
          {/* <Route path="*" element={<Navigate to="/" />} /> */}
          <Route path="/collaborative-editor" element={<CollaborativeEditor data={test_data} columnDefs={columnDefs} />} />
          <Route path="/preview" element={<PreviewPage />} />
        </Routes>
      </BrowserRouter>
      {/* <FeedbackModal user={user} /> */}
    </div>
  );
}

export default App;